module.exports = __webpack_public_path__ + "media/images/categories/5-387493e7223d5106bbd1aaa0813bd7fa.png";